import { useEffect, useState } from "react";
import {
    List,
    TextField,
    TopToolbar,
    CreateButton,
    DatagridConfigurable,
    SelectColumnsButton,
    TextInput,
    useDataProvider,
    SelectInput,
    useListContext,
    Button,
    useNotify
} from "react-admin";
import DownloadIcon from '@mui/icons-material/Download';

// const customExporter = (records: any[], fetchRelatedRecords: any) => {
//     // 定义您想要的字段顺序（与 Datagrid 中的顺序一致）
//     const fieldsOrder = [
//         "id",
//         "orderNo",
//         "batchNo",
//         "manufacturerId",
//         "deviceName",
//         "deviceType",
//         "productModel",
//         "deviceBrand",
//         "softVersion",
//         "firmware",
//         "sn",
//         "macAddress",
//         "wifissid24",
//         "wifissid50",
//         "ssidPassword",
//         "accessIpAddress",
//         "accessPassword",
//         "cmitId",
//         "deviceKey"
//     ];

//     // 定义 CSV 标题行（与 Datagrid 中的标签一致）
//     const headers = [
//         "Id",
//         "OrderNo",
//         "BatchNo",
//         "ManufacturerID",
//         "DeviceName",
//         "DeviceType",
//         "ProductModel",
//         "DeviceBrand",
//         "SoftVersion",
//         "Firmware",
//         "DeviceSerialNumber",
//         "MACAddress",
//         "SSID2.4G",
//         "SSID5G",
//         "SSIDKEY",
//         "AccessIPAddress",
//         "AccessPassword",
//         "CMIITID",
//         "DeviceKey"
//     ];

//     // 创建 CSV 内容
//     let csvContent = headers.join(",") + "\n";

//     records.forEach(record => {
//         const row = fieldsOrder.map(field => {
//             // 处理可能包含逗号的值
//             let value = record[field] || "";
//             if (typeof value === "string" && value.includes(",")) {
//                 return `"${value}"`;
//             }
//             return value;
//         });
//         csvContent += row.join(",") + "\n";
//     });

//     // 创建并下载 CSV 文件
//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const link = document.createElement("a");
//     const url = URL.createObjectURL(blob);
//     link.setAttribute("href", url);
//     link.setAttribute("download", "factory-testing-data.csv");
//     link.style.visibility = "hidden";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
// };


const ListActions = () => {
    const { setFilters, filterValues } = useListContext();  // 获取列表上下文
    const initialFilters = {};  // 初始过滤器值
    const dataProvider = useDataProvider(); // 获取数据提供者
    const notify = useNotify(); // 获取通知方法

    // 重置过滤器函数
    const handleResetFilters = () => {
        setFilters(initialFilters);
    };

    const rxportClick = () => {
        if (window.confirm(`确定导出序列号？`)) {
            const formData = {
                batchNo: filterValues.batchNo || '',
                orderNo: filterValues.orderNo || '',
                sn: filterValues.sn || '',
                deviceType: filterValues.deviceType || ''
            };
            dataProvider.deviceSnExport(formData)
                .then(() => {
                    notify('导出序列号成功', { type: 'success' });
                })
                .catch((error: any) => {
                    notify(error.message || '导出序列号失败', { type: 'error' });
                });
        }
    }

    return (
        <TopToolbar>
            <Button
                label="重置搜索"
                onClick={handleResetFilters}
                disabled={Object.keys(filterValues).length === 0}  // 当没有过滤条件时禁用
            />
            <SelectColumnsButton />
            <CreateButton />
            <Button
                size="small"
                label="导出"
                component="a"
                onClick={rxportClick}
                startIcon={<DownloadIcon />}
                sx={{ ml: 1 }}
            >
            </Button>
        </TopToolbar>
    );
};


export const factoryTestingList = () => {
    const dataProvider = useDataProvider(); // 获取dataProvider
    const [deviceTypes, setDeviceTypes] = useState([]);

    useEffect(() => {
        const fetchDeviceTypes = async () => {
            try {
                const deviceListResponse = await dataProvider.getDeviceList()

                const deviceTypesData = Array.isArray(deviceListResponse)
                    ? deviceListResponse
                    : deviceListResponse?.data || [];

                const types = deviceTypesData.map((item) => ({
                    id: item.name,
                    name: item.name
                }));

                setDeviceTypes(types);
            } catch (error) {
                console.error("获取客户类型失败:", error);
            }
        };

        fetchDeviceTypes();
    }, []);

    const postFilters = [
        <TextInput
            label="设备SN"
            alwaysOn
            source="sn"
        />,
        <TextInput
            label="批次号"
            alwaysOn
            source="batchNo"
        />,
        <TextInput
            label="订单号"
            alwaysOn
            source="orderNo"
        />,
        <SelectInput
            alwaysOn
            source="deviceType"
            label="设备类型"
            choices={deviceTypes}
        />
    ];

    return (
        <List filters={postFilters} actions={<ListActions />} empty={false}
            sx={{
                "& .RaList-content": {
                    overflow: "auto",
                    minHeight: "calc(100vh - 200px)"
                }
            }}>
            <DatagridConfigurable bulkActionButtons={false} >
                <TextField source="id" label="Id" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="orderNo" label="OrderNo" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="batchNo" label="BatchNo" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="manufacturerId" label="ManufacturerID" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="deviceName" label="DeviceName" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="deviceType" label="DeviceType" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="productModel" label="ProductModel" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="deviceBrand" label="DeviceBrand" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="softVersion" label="SoftVersion" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="firmware" label="FirmwareVersion" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="hwVersion" label="HardwareVersion" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="sn" label="DeviceSerialNumber" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="macAddress" label="MACAddress" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="wifissid24" label="SSID2.4G" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="wifissid50" label="SSID5G" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="ssidPassword" label="SSIDKEY" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="accessIpAddress" label="AccessIPAddress" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="accessPassword" label="AccessPassword" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="cmitId" label="CMIITID" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
                <TextField source="deviceKey" label="DeviceKey" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }} />
            </DatagridConfigurable>
        </List>
    )
}